import { CircularProgress, Fade, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
// import useWindowDimensions from "../utils/useWindowDimensions";

function ThreeSixtyImage({
  currentPose,
  currentAngle,
}) {

  let uri = process.env.REACT_APP_BASE_URL;

  // const { height, width } = useWindowDimensions();
  // const isLandscape = parseInt(height) > parseInt(width) ? false : true;
  const ALLOWED_KEYS = ["ArrowLeft", "ArrowRight"];
  
  const [isLoading, setIsLoading] = useState(true)
  // const [dragPosX, setDragPosX] = useState(null);


  useEffect(() => {
    setIsLoading(true);
  }, [currentPose, currentAngle])

  const imageIsPressed = useRef()
  const setImageIsPressed = (value) => {
    imageIsPressed.current = value
  }
  const dragPosX = useRef()
  const setDragPosX = (value) => {
    dragPosX.current = value
  }

  
  const [imageIndex, _setImageIndex] = useState(0);
  const imageIndexRef = useRef(imageIndex)
  const setImageIndex = (value) => {
    imageIndexRef.current = value;
    _setImageIndex(value)
  }


  const rotateRight = () => {
    if (imageIndexRef.current === 35) setImageIndex(0);
    else setImageIndex(imageIndexRef.current + 1);
  };

  const rotateLeft = () => {
    if (imageIndexRef.current === 0) setImageIndex(35);
    else setImageIndex(imageIndexRef.current - 1);
  };


  const handleKeyDown = ({ key }) => {

    if (ALLOWED_KEYS.includes(key)) {
      if (key === "ArrowLeft") rotateRight();
      else rotateLeft();
    }
  };

  const handleMouseDown = () => {
    setImageIsPressed(true)
  };

  const handleMouseUp = () => {
    setImageIsPressed(false)
  };

  const handleMouseMove = (e) => {


    if(imageIsPressed.current)
    {
      
      let screenX;
      
      if(typeof(e.screenX) === 'undefined') // touch?
        screenX = e.touches[0].screenX;
        else
        screenX = e.screenX;

      if(!dragPosX.current)
        setDragPosX(screenX)
      if(screenX > dragPosX.current && screenX - dragPosX.current > 20)
      {
          rotateLeft();
          setDragPosX(screenX)
      }

      if(screenX < dragPosX.current && dragPosX.current - screenX > 20)
      {
        rotateRight();
          setDragPosX(screenX)
      }
    }  
  };

  const enableImage = () => { 
    setIsLoading(false)
  }
  

  React.useEffect(() => {
    
    //arrows
    document.addEventListener("keydown", handleKeyDown);
    // mouse
    document.getElementById('threesixty_image').addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("touchmove", handleMouseMove);
    // touch
    document.getElementById('threesixty_image').addEventListener("touchstart", handleMouseDown);
    document.addEventListener("touchend", handleMouseUp);

    return () => {
      
      //arrows
      document.removeEventListener("keydown", handleKeyDown);
      // mouse
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("mousemove", handleMouseMove);
      // touch
      document.removeEventListener("touchstart", handleMouseDown);
      document.removeEventListener("touchend", handleMouseUp);
      document.removeEventListener("touchmove", handleMouseMove);
    };
  }, []);
  

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Fade in={isLoading} timeout={500}>
      <div className='loader'>
            <CircularProgress/>
          </div>
          </Fade>
      <Fade in={!isLoading} timeout={500}>    
      <Stack className="images" id="threesixty_image">
        {[...Array(36)].map((x, i) => {
          return (
            <img
              alt="360 model"
              draggable="false"
              onLoad={() => {
                if (i === 28)
                    enableImage();
              }}
              style={{ maxHeight: "100vh", maxWidth: "100%" }}
              className={(imageIndex !== i && "hidden")}
              src={
                uri + "images/360/" +
                currentPose +
                "/" +
                currentAngle +
                "/" +
                i +
                ".jpg"
              }
              key={i}
            />
          );
        })}
      </Stack>
      </Fade>
    </Stack>
  );
}

export default ThreeSixtyImage;
